import { Link } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { IconContext } from "react-icons";

import MenuLink from "../MenuLink";
import style from "./Menu.module.scss";
import logo from "./logo.png"
import Input from "componentes/Input";


function Menu() {

  return (
    <>
      <header className={style.cabecalho}>
        <Link to="./">
          <img src={logo} alt="logo"></img>
        </Link>
        <div className={style.cabecalho__container}>
          <Input
            className={style.cabecalho__input}
            label=""
            placeholder="Pesquisar"
            aoAlterado=""
            value=""
            tipo="search"
          />
          <IconContext.Provider value={{ color: 'orange' }}>
            <BsSearch />
          </IconContext.Provider>
        </div>
      </header>

      <nav className={style.menu}>
        <MenuLink to="/">Home</MenuLink>
        <MenuLink to="/procura-se">Procura-se</MenuLink>
        <MenuLink to="/encontrados">Encontrados</MenuLink>
        <MenuLink to="/adote">Adote</MenuLink>
        <MenuLink to="/petfriendly">Lugares Pet Friendly</MenuLink>
        <MenuLink to="/formdesaparecimento">Informar Desaparecimento</MenuLink>
      </nav>

    </>


  );
}

export default Menu;